package config

import kotlinx.browser.window

object ApiConfig {
    /**
     * APIエンドポイントURL
     * 
     * 優先順位:
     * 1. window.API_ENDPOINT (index.htmlで設定)
     * 2. 環境に応じたデフォルト値
     */
    val apiEndpoint: String
        get() {
            // index.htmlで設定されたグローバル変数を優先
            val globalEndpoint = js("(typeof window !== 'undefined' && window.API_ENDPOINT && window.API_ENDPOINT !== '__API_ENDPOINT__') ? window.API_ENDPOINT : null") as String?
            if (!globalEndpoint.isNullOrEmpty()) {
                return globalEndpoint
            }
            
            // ホスト名に基づいてエンドポイントを決定
            val hostname = window.location.hostname
            
            return when {
                // 本番環境（独自ドメイン）
                hostname == "nba-iso-flow.com" || hostname == "www.nba-iso-flow.com" ->
                    "https://nba-iso-flow.com/graphql"
                
                // CloudFrontドメインで直接アクセスされた場合
                hostname.contains("cloudfront.net") ->
                    "https://${hostname}/graphql"
                
                // ローカル開発環境（webpack-dev-serverのプロキシ経由）
                hostname == "localhost" || hostname == "127.0.0.1" ->
                    "/graphql"

                // デフォルト値
                else -> "/graphql"
            }
        }
    
    init {
        val hostname = window.location.hostname
        if (hostname == "localhost" || hostname == "127.0.0.1" || hostname == "::1") {
            console.log("API Endpoint configured as: $apiEndpoint")
        }
    }
}
